import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { getProviders } from '../../../api/providers';

export default function ProvidersPage() {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['providers'],
    queryFn: getProviders,
  });

  const providers = data?.data ?? [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <div>
        <h1 style={{ margin: 0, fontSize: '2rem', color: '#111827' }}>
          Providers
        </h1>
        <p style={{ marginTop: '8px', color: '#6b7280', lineHeight: 1.6 }}>
          Browse provider records from the new HnB backend and use this screen as
          the foundation for provider discovery and admin review.
        </p>
      </div>

      {isLoading && (
        <div
          style={{
            background: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: '14px',
            padding: '18px',
            color: '#4b5563',
          }}
        >
          Loading providers...
        </div>
      )}

      {isError && (
        <div
          style={{
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '14px',
            padding: '18px',
            color: '#b91c1c',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          <div>
            Failed to load providers:{' '}
            {error instanceof Error ? error.message : 'Unknown error'}
          </div>

          <button
            type="button"
            onClick={() => refetch()}
            style={{
              alignSelf: 'flex-start',
              background: '#111827',
              color: '#ffffff',
              border: 'none',
              borderRadius: '10px',
              padding: '10px 14px',
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Retry
          </button>
        </div>
      )}

      {!isLoading && !isError && providers.length === 0 && (
        <div
          style={{
            background: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: '14px',
            padding: '24px',
            color: '#6b7280',
          }}
        >
          No providers found yet.
        </div>
      )}

      {!isLoading && !isError && providers.length > 0 && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '16px',
          }}
        >
          {providers.map((provider: import('../../../api/providers').Provider) => (
            <Link
              key={provider.id}
              to={`/dashboard/providers/${provider.id}`}
              style={{
                textDecoration: 'none',
                color: '#111827',
                background: '#ffffff',
                border: '1px solid #e5e7eb',
                borderRadius: '14px',
                padding: '18px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <h2 style={{ margin: 0, fontSize: '1.1rem' }}>
                {provider.businessName}
              </h2>

              <div style={{ color: '#6b7280', lineHeight: 1.6 }}>
                <div>{provider.city ?? 'City not available'}</div>
                <div>{provider.postcode ?? 'Postcode not available'}</div>
                <div>Status: {provider.status ?? 'Unknown'}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}